import React from 'react'
import grn from '../Assets/green_bg.png'
import red from '../Assets/red_bg.png'
import n5 from '../Assets/n5_bg.png'
import n0 from '../Assets/n0_bg.png'

const Selected = ({ i }) => {
  return (
            <div style={{ maxWidth:'30px', }} className='container flex justify-center items-center cursor-pointer'>
            { i % 2 !== 0 && i !== 5 && <img style={{ maxWidth:'30px', }} src={grn} alt='' className="image"/>}      
            { i % 2 === 0 && i !== 0 && <img style={{ maxWidth:'30px', }} src={red} alt=''/>}
            { i === 0 && <img style={{ maxWidth:'30px', }} src={n0} alt=''/>}
            { i === 5 && <img className='image' style={{ maxWidth:'30px', }} src={n5} alt=''/>}
            <div className={`ballnumber ${i % 2 !== 0 && 'text-green-500'} ${i % 2 === 0  && 'text-red-500'}`}>{i}</div>
            </div>
  )
}

export default Selected